import { yupResolver } from '@hookform/resolvers/yup';
import { FirebaseError } from 'firebase/app';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { firebaseAuth } from '../../firebase/firebase.service';
import { useFirebaseErrorHandler } from '../hooks/useFirebaseErrorHandler';

interface LoginInputs {
  email: string;
  password: string;
}

const schema = yup
  .object({
    email: yup.string().trim().email().required("L'email est requis"),
    password: yup.string().trim().required('Le mot de passe est requis'),
  })
  .required();

export const useLogin = () => {
  const { handleFirebaseError } = useFirebaseErrorHandler();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginInputs>({
    resolver: yupResolver(schema),
  });

  const onValid: SubmitHandler<LoginInputs> = async (data) => {
    try {
      await signInWithEmailAndPassword(firebaseAuth, data.email, data.password);
      navigate('/dashboard');
    } catch (err) {
      const error = err as FirebaseError;
      handleFirebaseError(error);
    }
  };
  const onSubmit = handleSubmit(onValid);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const toggleIsPasswordVisible = () =>
    setIsPasswordVisible((isVisible) => !isVisible);

  return {
    register,
    errors,
    onSubmit,
    toggleIsPasswordVisible,
    isPasswordVisible,
  };
};
